import {AssetType} from '@sollapay/enums';
import {z} from 'zod';

/** Only the two fields with a live "still missing" hint — every descriptor field is optional. */
export const AssetDetailsRequiredFieldsSchema = z.object({
  assetType: z
    .union([z.nativeEnum(AssetType), z.literal('')])
    .refine(v => v !== '', {message: 'common:required'}),
  referencePriceNis: z.string().min(1, 'common:required')
});
